// @greenlight-spec: 20-agent-plugins.md#marketplace-repo-bootstrap

import type { PluginMarketplaceStatus } from '@greenlight/shared';

/** Replace-or-append by repo full name, keeping the server's name ordering. */
export function mergeRepository(
  repositories: PluginMarketplaceStatus[],
  incoming: PluginMarketplaceStatus,
): PluginMarketplaceStatus[] {
  return [
    ...repositories.filter((repo) => repo.repo_full_name !== incoming.repo_full_name),
    incoming,
  ].sort((left, right) => left.repo_full_name.localeCompare(right.repo_full_name));
}
